export const permissions = {
  REPORTS: "Permission.Reports",
  REPORT_ANALYTICS: "Permission.Reports.Analytics",
  REPORT_MANIFEST_TRACKER: "Permission.Reports.Manifest",
  REPORT_PNCF_TRACKER: "Permission.Reports.PNCF",
  REPORT_FLIGHT_TRACKER: "Permission.Reports.FlightTracker",
  FLIGHTOPS: "Permission.FlightOps",
  FLIGHTOPS_INITIATE: "Permission.FlightOps.Initiate",
  FLIGHTOPS_APPROVE: "Permission.FlightOps.Approve",
  BILLING: "Permission.Billing",
  BILLING_INITIATE: "Permission.Billing.Initiate",
  BILLING_APPROVE: "Permission.Billing.Approve",
  OPERATIONS: "Permission.Operations",
  OPERATIONS_INITIATE: "Permission.Operations.Initiate",
  OPERATIONS_APPROVE: "Permission.Operations.Approve",
  AUDIT_LOG: "Permission.AuditLog",
  USER: "Permission.User",
};
export const organizationType = {
  NCAA: "NCAA",
  OPERATOR: "Operator",
};
export enum organizationTypeValues {
  AVITECH = 1,
  NCAA = 2,
  OPERATOR = 3,
}

const roles = {
  ADMIN: "Role.Admin",
  USER: "Role.User",
};

export const organizationsTypes = [
  {
    id: 1,
    name: "Avitech",
  },
  {
    id: 2,
    name: "NCAA",
  },
  {
    id: 3,
    name: "Operator",
  },
];

export const parsePermissions = (permissions: string[]) => {
  const structuredPermissions = {} as Record<string, Set<string>>;

  permissions.forEach((permission) => {
    const parts = permission.split(".");
    const [_, module, action] = parts;

    if (!structuredPermissions[module]) {
      structuredPermissions[module] = new Set();
    }

    if (action) {
      structuredPermissions[module].add(action);
    }
  });

  return structuredPermissions;
};

export const hasPermission = (
  userPermissions: string[] = [],
  requiredPermissions: string[] = [],
  allowedOrgTypes: string[] = [],
  orgType?: string
) => {
  // Check permissions
  const permissionCheck =
    requiredPermissions.length === 0 ||
    requiredPermissions.every((permission) =>
      userPermissions.includes(permission)
    );

  // Check organization type
  const orgTypeCheck =
    allowedOrgTypes.length === 0 || allowedOrgTypes.includes(orgType ?? "");

  return permissionCheck && orgTypeCheck;
};
